import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit {
  _type: string;
  _badgeNumber: number;
  _badgeStyle: string;
  _viewStyle: string;
  _text: string;

  @Input()
  get type(): any {
    return this._type;
  }
  set type(value: any) {
    this._type = value || 'icon';
  }

  @Input()
  get badgeNumber(): any {
    return this._badgeNumber;
  }
  set badgeNumber(value: any) {
    this._badgeNumber = value || 'icon';
  }

  @Input()
  get badgeStyle(): any {
    return this._badgeStyle;
  }
  set badgeStyle(value: any) {
    this._badgeStyle = value || '';
  }

  @Input()
  get viewStyle(): any {
    return this._viewStyle;
  }
  set viewStyle(value: any) {
    this._viewStyle = value || 'font-size: 2em; color: black';
  }

  @Input()
  get text(): any {
    return this._text;
  }
  set text(value: any) {
    this._text = value || '';
  }

  constructor() {
    //TODO
  }

  ngOnInit(): void {
    //TODO
  }
}
